import { render, staticRenderFns } from "./BuyNowButton.vue?vue&type=template&id=ac5f1bbe&scoped=true&"
import script from "./BuyNowButton.vue?vue&type=script&lang=js&"
export * from "./BuyNowButton.vue?vue&type=script&lang=js&"
import style0 from "./BuyNowButton.vue?vue&type=style&index=0&id=ac5f1bbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac5f1bbe",
  null
  
)

export default component.exports